<div class="popover-close d-flex" [class.one-product]="(productsCountInPopover$ | async) === 1">
  <button mat-icon-button class="popover-close-button" [disableRipple]="true" [disabled]="showSpinnerPopover">
    <mat-icon class="popover-close-button-icon">close</mat-icon>
  </button>
</div>
@for (product of products$ | async; track product; let productIndex = $index) { @if (isActive(product?.bomItemNo)) {
<div #popoverProductListing class="product" [id]="product?.bomItemNo">
  <div class="product-details">
    <span class="sku mr-1">{{ product?.code }}</span>
    @switch (checkStockLevel(product.stock?.stockLevel, product.stock?.stockLevelStatus)) { @case ('inStock') {
    <span class="in-stock">{{ 'product.inStock' | cxTranslate }}</span>
    } @case ('outOfStock') {
    <span class="no-stock">{{ 'product.noStock' | cxTranslate }}</span>
    } @case ('discontinued') {
    <span class="discontinued">{{ 'product.discontinued' | cxTranslate }}</span>
    } }
    <span class="text-truncate name" [title]="product?.name">{{ product?.name }}</span>
  </div>
  <div class="line-break"></div>
</div>
} @if (isActive(product?.bomItemNo)) {
<div>
  <ng-container [ngTemplateOutlet]="productDetailsMore" [ngTemplateOutletContext]="{ product: product }"></ng-container>
</div>
} }
<ng-template #productDetailsMore let-product="product">
  <div class="product-details-more">
    <div
      class="prices"
      [ngClass]="activeLanguage$ | async"
      [class.gst-labels-on]="(showGstInclusive$ | async) || (showGstExclusive$ | async)"
    >
      <div class="srpPrice">
        <span>{{ 'product.productList.srp' | cxTranslate }}</span>
        <span>{{ getSrpPrice(product?.code) | async }}</span>
        @if ((getSrpPrice(product?.code) | async) && showGstInclusive$ | async) {
        <span class="gst-label">{{ 'gst.inclusive' | cxTranslate }}</span>
        }
      </div>
      @if (!showSrpOnly) { @if (!basepriceHiddens) {
      <div class="basePrice">
        <span>{{ 'product.productList.basePrice' | cxTranslate }}</span>
        <span>{{ getBasePrice(product?.code) | async }}</span>
        @if ((getBasePrice(product?.code) | async) && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
        }
      </div>
      }
      <div class="dealerPrice">
        <span>{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
        @if (!dealerPrice(product?.code)) {
        <div class="spinner-shimano-wrapper-dp">
          @if (this.hasDealerPrice) {
          <div class="spinner-shimano ev">
            <div></div>
          </div>
          } @if (!this.hasDealerPrice) {
          <span class="no-dealer-price no-dealer-price-ev"></span>
          }
        </div>
        } @else {
        <span>{{ getDealerPrice(product?.code) | async }}</span>
        @if (dealerPrice(product?.code) && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
        } }
      </div>
      }
    </div>
    <div class="actions">
      <div class="pdp">
        @if (isDesktop) { @if (product && !isPlpPopupEnabled) {
        <button
          mat-icon-button
          class="assignment rounded-0"
          [disableRipple]="true"
          matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
        >
          <mat-icon>assignment</mat-icon>
        </button>
        } @if (isPlpPopupEnabled) {
        <div [ngTemplateOutlet]="detailsButton"></div>
        } } @else { @if (product && !isPlpPopupEnabled) {
        <button
          mat-icon-button
          class="assignment rounded-0"
          [disableRipple]="true"
          attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
        >
          <mat-icon>assignment</mat-icon>
        </button>
        } @if (isPlpPopupEnabled) {
        <div [ngTemplateOutlet]="detailsButton"></div>
        } }
        <ng-template #detailsButton>
          <div class="details-button-pdp">
            <button
              class="details-button secondary-btn btn-block btn"
              type="button"
              matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
              attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            >
              {{ 'buttonTooltip.plp.pdpDetailsButton' | cxTranslate }}
            </button>
          </div>
        </ng-template>
      </div>
      @if (product) {
      <div class="add-to-cart" [formGroup]="explodedViewFormGroup">
        <div class="quantity">
          <fieldset
            [disabled]="
              (isOutOfStock(product?.code) | async) || !(getDealerPrice(product?.code) | async)?.toString().length
            "
          >
            <input
              #quantityInput
              class="form-control"
              type="number"
              min="0"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
              maxlength="3"
              [formControlName]="product?.code"
              (change)="checkInput($event, product?.code)"
            />
          </fieldset>
        </div>
        @if (isDesktop) {
        <button
          mat-icon-button
          [ngClass]="'sku-' + [product.code]"
          class="add-to-cart-primary rounded-0"
          [disableRipple]="true"
          matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
          attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          (click)="backorderCartCheck(product)"
          [disabled]="
            !quantityInput.value ||
            (isOutOfStock(product?.code) | async) ||
            !(getDealerPrice(product?.code) | async)?.toString().length ||
            showSpinnerPopover
          "
        >
          <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
        </button>
        } @else {
        <button
          mat-icon-button
          [ngClass]="'sku-' + [product.code]"
          class="add-to-cart-primary rounded-0"
          [disableRipple]="true"
          attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
          (click)="backorderCartCheck(product)"
          [disabled]="
            !quantityInput.value ||
            (isOutOfStock(product?.code) | async) ||
            !(getDealerPrice(product?.code) | async)?.toString().length ||
            showSpinnerPopover
          "
        >
          <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
        </button>
        }
      </div>
      }
    </div>
  </div>
</ng-template>
